import { Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'

import { AuthHeading, AuthLayout } from '@/features/auth/components/auth-layout'
import { Button } from '@/shared/ui/button'

/**
 * Where the identity provider sends the browser once it has ended its own session.
 *
 * This page renders without a session and must not start a sign-in of its own.
 * That is the entire reason it exists: sending the browser to `/login` instead
 * would meet a single sign-on session that has just been ended, or -- if anything
 * went wrong ending it -- one that has not, and sign the person straight back in.
 * Either way "Sign out" would look like it did nothing.
 */
export function SignedOutPage() {
  const { t } = useTranslation()

  return (
    <AuthLayout>
      <AuthHeading eyebrow={t('signedOut.eyebrow')} heading={t('signedOut.title')}>
        <p className="text-muted-foreground text-sm leading-relaxed">
          {t('signedOut.description')}
        </p>
      </AuthHeading>
      <Button asChild className="self-start">
        <Link to="/login">{t('signedOut.signBackIn')}</Link>
      </Button>
    </AuthLayout>
  )
}
